import { __extends } from "tslib";
import { addClass, getShadowElement, removeAllChildren, removeClass, toggleElementPlaceholder } from '@tyler-components-web/core';
import { toggleClass } from '../core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { PAGINATOR_CONSTANTS } from './paginator-constants';
/**
 * Provides facilities for interacting with the internal DOM of `PaginatorComponent`.
 */
var PaginatorAdapter = /** @class */ (function (_super) {
    __extends(PaginatorAdapter, _super);
    function PaginatorAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._labelElement = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.LABEL);
        _this._root = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.ROOT);
        _this._pageSizeSelect = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.PAGE_SIZE_SELECT);
        _this._rangeLabel = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.RANGE_LABEL);
        _this._rangeLabelAlternative = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.RANGE_LABEL_ALTERNATIVE);
        _this._firstPageButton = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.FIRST_PAGE_BUTTON);
        _this._firstPageIconButton = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.FIRST_PAGE_ICON_BUTTON);
        _this._previousPageButton = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.PREVIOUS_PAGE_BUTTON);
        _this._nextPageButton = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.NEXT_PAGE_BUTTON);
        _this._lastPageButton = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.LAST_PAGE_BUTTON);
        _this._lastPageIconButton = getShadowElement(component, PAGINATOR_CONSTANTS.selectors.LAST_PAGE_ICON_BUTTON);
        return _this;
    }
    PaginatorAdapter.prototype.setLabel = function (value) {
        this._labelElement.textContent = value;
    };
    PaginatorAdapter.prototype.setPageSizeOptions = function (options) {
        removeAllChildren(this._pageSizeSelect);
        this._pageSizeSelect.options = options;
    };
    PaginatorAdapter.prototype.setPageSize = function (value) {
        this._pageSizeSelect.value = value.toString();
    };
    PaginatorAdapter.prototype.setRangeLabel = function (value) {
        this._rangeLabel.innerText = value;
        this._rangeLabelAlternative.innerText = value;
    };
    PaginatorAdapter.prototype.hasFirstPageButton = function () {
        return !!getShadowElement(this._component, PAGINATOR_CONSTANTS.selectors.FIRST_PAGE_ICON_BUTTON);
    };
    PaginatorAdapter.prototype.showFirstPageButton = function () {
        this._firstPagePlaceholder = toggleElementPlaceholder(this._component, true, PAGINATOR_CONSTANTS.elementName, PAGINATOR_CONSTANTS.selectors.FIRST_PAGE_ICON_BUTTON, this._firstPageIconButton, this._firstPagePlaceholder);
    };
    PaginatorAdapter.prototype.hideFirstPageButton = function () {
        this._firstPagePlaceholder = toggleElementPlaceholder(this._component, false, PAGINATOR_CONSTANTS.elementName, PAGINATOR_CONSTANTS.selectors.FIRST_PAGE_ICON_BUTTON, this._firstPageIconButton, this._firstPagePlaceholder);
    };
    PaginatorAdapter.prototype.hasLastPageButton = function () {
        return !!getShadowElement(this._component, PAGINATOR_CONSTANTS.selectors.LAST_PAGE_ICON_BUTTON);
    };
    PaginatorAdapter.prototype.showLastPageButton = function () {
        this._lastPagePlaceholder = toggleElementPlaceholder(this._component, true, PAGINATOR_CONSTANTS.elementName, PAGINATOR_CONSTANTS.selectors.LAST_PAGE_ICON_BUTTON, this._lastPageIconButton, this._lastPagePlaceholder);
    };
    PaginatorAdapter.prototype.hideLastPageButton = function () {
        this._lastPagePlaceholder = toggleElementPlaceholder(this._component, false, PAGINATOR_CONSTANTS.elementName, PAGINATOR_CONSTANTS.selectors.LAST_PAGE_ICON_BUTTON, this._lastPageIconButton, this._lastPagePlaceholder);
    };
    PaginatorAdapter.prototype.attachPageSizeChangeListener = function (listener) {
        this._pageSizeSelect.addEventListener('change', listener);
    };
    PaginatorAdapter.prototype.attachFirstPageListener = function (listener) {
        this._firstPageButton.addEventListener('click', listener);
    };
    PaginatorAdapter.prototype.attachPreviousPageListener = function (listener) {
        this._previousPageButton.addEventListener('click', listener);
    };
    PaginatorAdapter.prototype.attachNextPageListener = function (listener) {
        this._nextPageButton.addEventListener('click', listener);
    };
    PaginatorAdapter.prototype.attachLastPageListener = function (listener) {
        this._lastPageButton.addEventListener('click', listener);
    };
    PaginatorAdapter.prototype.detachPageSizeChangeListener = function (listener) {
        this._pageSizeSelect.removeEventListener('change', listener);
    };
    PaginatorAdapter.prototype.detachFirstPageListener = function (listener) {
        this._firstPageButton.removeEventListener('click', listener);
    };
    PaginatorAdapter.prototype.detachPreviousPageListener = function (listener) {
        this._previousPageButton.removeEventListener('click', listener);
    };
    PaginatorAdapter.prototype.detachNextPageListener = function (listener) {
        this._nextPageButton.removeEventListener('click', listener);
    };
    PaginatorAdapter.prototype.detachLastPageListener = function (listener) {
        this._lastPageButton.removeEventListener('click', listener);
    };
    PaginatorAdapter.prototype.disableFirstPageButton = function () {
        this._firstPageButton.setAttribute('disabled', 'disabled');
    };
    PaginatorAdapter.prototype.enableFirstPageButton = function () {
        this._firstPageButton.removeAttribute('disabled');
    };
    PaginatorAdapter.prototype.disablePreviousPageButton = function () {
        this._previousPageButton.setAttribute('disabled', 'disabled');
    };
    PaginatorAdapter.prototype.enablePreviousPageButton = function () {
        this._previousPageButton.removeAttribute('disabled');
    };
    PaginatorAdapter.prototype.disableNextPageButton = function () {
        this._nextPageButton.setAttribute('disabled', 'disabled');
    };
    PaginatorAdapter.prototype.enableNextPageButton = function () {
        this._nextPageButton.removeAttribute('disabled');
    };
    PaginatorAdapter.prototype.disablePageSizeSelect = function () {
        this._pageSizeSelect.setAttribute('disabled', 'disabled');
    };
    PaginatorAdapter.prototype.enablePageSizeSelect = function () {
        this._pageSizeSelect.removeAttribute('disabled');
    };
    PaginatorAdapter.prototype.setPageSizeVisibility = function (visible) {
        visible ? this._pageSizeSelect.style.removeProperty('display') : (this._pageSizeSelect.style.display = 'none');
    };
    PaginatorAdapter.prototype.disableLastPageButton = function () {
        this._lastPageButton.setAttribute('disabled', 'disabled');
    };
    PaginatorAdapter.prototype.enableLastPageButton = function () {
        this._lastPageButton.removeAttribute('disabled');
    };
    PaginatorAdapter.prototype.setAlternative = function (alternative) {
        toggleClass(this._root, alternative, PAGINATOR_CONSTANTS.classes.ALTERNATIVE);
    };
    PaginatorAdapter.prototype.setAlignment = function (alignment) {
        removeClass([
            PAGINATOR_CONSTANTS.classes.ALIGNMENT_SPACE_BETWEEN,
            PAGINATOR_CONSTANTS.classes.ALIGNMENT_START,
            PAGINATOR_CONSTANTS.classes.ALIGNMENT_END
        ], this._root);
        switch (alignment) {
            case 'start':
                addClass(PAGINATOR_CONSTANTS.classes.ALIGNMENT_START, this._root);
                break;
            case 'end':
                addClass(PAGINATOR_CONSTANTS.classes.ALIGNMENT_END, this._root);
                break;
            case 'space-between':
            default:
                addClass(PAGINATOR_CONSTANTS.classes.ALIGNMENT_SPACE_BETWEEN, this._root);
                break;
        }
    };
    return PaginatorAdapter;
}(BaseAdapter));
export { PaginatorAdapter };
